import { styled, css } from 'styled-components'
import { LANGUAGES } from 'locale/Translation.consts'

export const Text = styled.div<{ $promo?: boolean; $highlighted?: boolean }>`
  font-size: 15.5px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  padding-right: 50px;

  ${({ $promo }) =>
    $promo &&
    css`
      font-weight: 500;
      line-height: 140%;
    `}

  ${({ theme }) =>
    theme.language === LANGUAGES.JAPANESE &&
    css`
      font-size: 14px;
    `}
`

export const SheetButton = styled.div<{ $promo?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  font-weight: 700;
  color: #2b0514; // theme.colors.black
  height: 40px;

  &.all-is-clickable {
    cursor: pointer;
  }

  &.highlighted {
    color: #eb2371; // theme.colors.primary
  }

  &.disable-click {
    cursor: default;
  }

  .button-icon {
    display: flex;
    width: 38px;
    padding-left: 0;
    align-items: center;
    box-sizing: border-box;

    &.highlighted {
      path {
        fill: #eb2371; // theme.colors.primary
      }
    }

    ${({ $promo }) =>
      !$promo &&
      css`
        margin: 12px 0;
      `}
`
